import React from "react";
import { observer } from "mobx-react-lite";
import Select from "react-select";

const GS1ParamsTypeSelect = observer(({ store, isDisabled = false }) => {
  return (<>
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={store?.options()}
        //defaultValue={store?.selectedGS1Parameters ? store?.selectedGS1Parameters : []}
        value={store?.selectedGS1Parameters.map((param) => ({label: param.label, uuid: param.uuid}))}
        getOptionLabel={option => option.label}
        getOptionValue={option => option.uuid}
        onChange={(data) => store?.selectParameters(data)}
        placeholder="Select"
        isMulti
        isDisabled={isDisabled}
      />
    </>
  );
});

export default GS1ParamsTypeSelect;
